import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PrePagoenlinea } from '../Entidades/pre-pagoenlinea/pre-pagoenlinea.module';
import { Url } from 'url';

@Injectable({
  providedIn: 'root'
})
export class PredialUrbanoService {

  constructor(private http: HttpClient) { }

  GetCalcula_PU(cve_catast: string, año_hasta: string, trim_hasta: string) {
    return this.http.post<any>(environment.url_webapi + 'PagosPredial/GetCalcula_PU', { cve_catast: cve_catast, ano_hasta: año_hasta, trim_hasta: trim_hasta });
  }

  PrePagoEnLinea(pre_pago: PrePagoenlinea) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/PrePagoEnLinea", pre_pago);
  }

  GetVerificaRecibo(referencia: any) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/ConsultaRecibo", { referencia: referencia });
  }

  GetReciboVerificacion(referencia: any) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/ConsultaReciboVerificacion", { referencia: referencia });
  }


  GetVerificaPagoBajio(referencia: any) {
    return this.http.post<any>(environment.url_webapi + "Bajio/VerificaPago", { referencia: referencia });
  }

  GetGetOrderByAzteca(prepago: any) {
    return this.http.post<any>(environment.url_webapi + "BancoAzteca/Getorder", { ...prepago });
  }

  PagoBanorte(prepago: any) {
    return this.http.post<any>("https://via.pagosbanorte.com/payw2", prepago);
  }

  GetRecibo_PU(recibo: string) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/GetRecibo_PU", { recibo: recibo });
  }

  PostGuardarPrepagoBanorte(prepago_banorte: any) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/WritePrepagoBanorte", { VA: 'bysystem', ...prepago_banorte });
  }

  PostGuardarPrepagobajio(prepago: any) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/PrePagoEnLinea", { VA: 'bysystem', ...prepago });
  }

  PostSolicitarPaginaBajioPago(prepago_bajio: any) {
    return this.http.post<any>(environment.url_webapi + "Bajio/GenerarPago", { ...prepago_bajio });
  }

  PostSolicitarPaginaAztecaPago(prepago_azteca: any) {
    return this.http.post<any>(environment.url_webapi + "BancoAzteca/GenerarPago", { ...prepago_azteca });
  }

  // Estado del pago Azteca: el backend reconcilia con DEUNA si aun no hay recibo.
  GetEstadoPagoAzteca(referencia: string) {
    return this.http.post<any>(environment.url_webapi + "BancoAzteca/EstadoPago", { referencia: referencia });
  }


  PostGuardarPrepagoBanorteByCorreo(correo: any) {
    return this.http.post<any>(environment.url_webapi + "PagosPredial/ReadPrepagoBanorte", { VA: 'byid', correo: correo });
  }
}
